module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "news-list"
  }, _vm._l((_vm.newsdata), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": _vm.path + item.id,
        "title": item.title
      }
    }, [_c('h4', [_vm._v(_vm._s(item.title))]), _c('span', [_vm._v("发布日期： " + _vm._s(item.createdate ? item.createdate : item.date))])])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-203bfd14!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/News.vue
// module id = 165
// module chunks = 1